module.exports = __webpack_public_path__ + "static/media/play-boss-lose-4.1a960162.png";